export enum LicenseType {
  Full,
  Trial,
  Evaluation
}
